module.exports = __webpack_public_path__ + "img/zeedhi_new_logo.4b3a8b24.svg";